import React from "react";
import { PostActionButton } from "./PostCard.styles";
import Images from "config/Images";

const CommentAction: React.FC<CommentActionProps> = ({
  post,
  handlePostClick,
}) => {

  return (
    <PostActionButton onClick={() => handlePostClick(post.id)}>
      <img src={Images.messageIcon} alt="Comment" /> Comment
    </PostActionButton>
  );
};

export default CommentAction;
